import { gql } from 'glimmer-apollo';

export const ESPORTS_TOP_PLAYERS_QUERY = gql`
  query EsportsTopPlayers($limit: Int = 5) {
    players(limit: $limit) {
      gamertag
      slug
      irlName
      role
      photo {
        url(width: 96, height: 96, fit: cover, format: webp)
      }
      currentTeam {
        name
        slug
        country
        logo {
          url(width: 48, height: 48, fit: cover, format: webp)
        }
      }
      # Stats would need to be calculated from matches
      # For now we'll use placeholder values in the component
    }
  }
`;